/*
 * @Author: bbqin
 * @Date: 2022-07-22 10:33:25
 * @LastEditTime: 2022-08-24 15:35:21
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\adapters\global.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
// 扩展platform样式表
import { 
    getGlobalStorage, 
    setGlobalStorage, 
    syncAjax, 
    addDataSign, 
    getCookie, 
    getTopWindow, 
    getBusinessInfo, 
    pageTo,
} from '@platform/api';

const GlobalExtend = 'NCCExtend';

function getExtendStyleAndJsSwitch() {
    if (NODE_ENV === 'development') {
        return;
    }

    let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch'));
    if (NCC_SYS_Switch === null) {
        let cookiets = (getTopWindow() && getTopWindow().cookiets) || getCookie('cookiets') || Date.now(); //双cookie验证 liuxis
        let reqData = {
            sysParamJson: {
                busiaction: '查询系统开关',
                pagecs: cookiets,
                ts: new Date().getTime(),
            },
        };
        
        // 做一次 数据转型
        cookiets = isNaN(cookiets) ? cookiets : Number(cookiets);
        let headers = { 'Content-Type': 'application/json;charset=UTF-8', cookiets };
        reqData = JSON.stringify(addDataSign(reqData, '', { allin: true, headers: headers }));
        syncAjax({
            type: 'post',
            url: '/nccloud/platform/total/switch.do',
            async: false,
            headers,
            data: reqData,
            success: res => {
                if (res) {
                    res = JSON.parse(res);
                    if (res.data) {
                        let NCC_SYS_Switch = res.data || {};
                        let localStorageSwitch = getGlobalStorage('localStorage', 'storeCipher');
                        //缓存是否加密开关变化了
                        if (localStorageSwitch != NCC_SYS_Switch.localStorage) {
                            //localStorage加密开关与上次不一致，则清空所有localStorage内容
                            localStorage.clear();
                        }
                        //setGlobalStorage('localStorage', 'NCC_SYS_Switch', JSON.stringify(NCC_SYS_Switch));
                        //setGlobalStorage('localStorage', 'storeCipher', NCC_SYS_Switch.localStorage ? '1' : '0');
                        localStorage.setItem('NCC_SYS_Switch', JSON.stringify(NCC_SYS_Switch));
                        //开启关闭自动化测试开关
                        localStorage.setItem('storeCipher', NCC_SYS_Switch.localStorage ? '1' : '0');
                        setGlobalStorage('localStorage', '_ncc_automated_', NCC_SYS_Switch.automated_test ? '1' : '0');
                        setGlobalStorage('localStorage', '_ncc_extend_style_', NCC_SYS_Switch.extendstyle ? '1' : '0');
                    }
                }
            },
        });
    }
}

const ExtendStyleAndJs = () => {
    getExtendStyleAndJsSwitch();
    let domHead = document.getElementsByTagName('HEAD').item(0);
    if (getGlobalStorage('localStorage', '_ncc_extend_style_') === '1') {
        // 插入新style
        let style = document.createElement('link');
        // 这里暂时没有考虑hash的情况 TODO
        style.href = `../../../../${GlobalExtend}/extend_platform/index.css`;
        style.rel = 'stylesheet';
        style.type = 'text/css';
        style.onerror = function (e) {
            console.log('未能platform扩展样式表', `${GlobalExtend}/extend_platform/index.css`);
        };
        domHead.appendChild(style);
    }
    let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch'));
    if (NCC_SYS_Switch && NCC_SYS_Switch.yyy) {
        // 插入新js
        let script = document.createElement('script');
        script.src = `../../../../platform/resource/yonyou-yyy/index.js`;
        script.type = 'text/javascript';
        domHead.appendChild(script);
    }

    if (NCC_SYS_Switch && NCC_SYS_Switch.ymc) {
        let script = document.createElement('script');
        script.src = decodeURIComponent(NCC_SYS_Switch.ymc);
        script.type = 'text/javascript';
        script.setAttribute('crossorigin', true);
        script.setAttribute('async', true);
        script.setAttribute('id', 'uba-sdk');
        script.onload = () => {
            window.uba.setConfig({
                getUser: () => {
                    let user = getBusinessInfo();
                    if (!user) {
                        return {};
                    }
                    return {
                        uc: user.userCode, // 用户编码
                        userid: user.userId, // 用户id
                        username: user.userName, // 用户名
                    };
                },
                getBizData: () => {
                    return {
                        ytid: 'ymc-uba-001', // 租户标识
                        ytname: 'ymc-uba-默认租户', // 租户名称
                        domaincode: pageTo.getSearchParam('fieldcode'), // 领域编码
                        domainname: pageTo.getSearchParam('b1'), // 领域名称
                        appcode: pageTo.getSearchParam('fifthmenucode') ? pageTo.getSearchParam('menucode') : pageTo.getSearchParam('menuclasscode'), // 应用编码
                        appname: pageTo.getSearchParam('b4') || pageTo.getSearchParam('b3'), // 应用名称
                        servicecode: pageTo.getSearchParam('fifthmenucode') || pageTo.getSearchParam('menucode'), // 服务编码
                        servicename: pageTo.getSearchParam('n'), // 服务名称
                    };
                },
            });
        };
        domHead.appendChild(script);
    }
};

export default ExtendStyleAndJs;

